const colorEyeBlack = (btn1, btn2, btn3) => {
  btn1.querySelectorAll('.far').forEach((element) => element.style.color = 'black');
  btn2.querySelectorAll('.far').forEach((element) => element.style.color = 'black');
  btn3.querySelectorAll('.far').forEach((element) => element.style.color = 'black');
}

export { colorEyeBlack };
